export default __webpack_public_path__ + "static/media/usuarios.dd556bb7.svg";